import {httpGet,httpPut,httpDelete,httpPost,httpDownload} from '../../../util/request.js';
import appConfig from '../../../config';

export default class VenderApi{
	
	static listVender(param){
        return this.httpRequest('list',param,'post');
    }
	
	static detailVender(param){
	    return this.httpRequest('detail',param,'post');
	}
	
	static updateVender(param){
	    return this.httpRequest('update',param,'post');
	}
	
	static setBlack(param){
	    return this.httpRequest('setblack',param,'post');
	}
	
	static setWhite(param){
	    return this.httpRequest('setwhite',param,'post');
	}
	
	static uploadFile(file){
	    let formData = new FormData()
	    formData.append('file', file);
	    return this.httpRequest('upload', formData,'post')
	}
	
	static importTemplate(params){
	    return httpDownload(this.baseUrl + "import/template",params);
	}
	
	static importData(file){
	    let formData = new FormData()
	    formData.append('file', file);
	    return httpPost(this.baseUrl + "import", formData);
	}
	
	static all(){
	    return httpGet(this.baseUrl + "all", {})
	}
	


    static baseUrl = appConfig.gatewayUrl+appConfig.appointmentServicePath + "/vender/";
    // static baseUrl = "http://localhost:20065/appointment-service" + "/vender/";
    // static baseUrl = "https://ssl.springland.com.cn/appointment-service" + "/vender/";

    static httpRequest(url, param, method ){
        if(method == 'get'){
            return httpGet(this.baseUrl + url, param);
        }
        if(method == 'post'){
            return httpPost(this.baseUrl + url, param);
        }
    }

    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

    static handleNetworkError(response, scope, errorFunc){
        scope.$dialog.error({
            text: response.message,
            title: "错误"
        });
        if(errorFunc && typeof errorFunc == 'function'){
            errorFunc(response);
        }
    }


}